async function updateDeliveryDetails(dets = "") {
    let formData = {
      attributes: dets
    };
  
    try {
      let response = await fetch(window.Shopify.routes.root + 'cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      });
  
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
  
      let data = await response.json();
      return data;
    } catch (error) {
      console.error('Error:', error);
      throw error; // Rethrow the error after logging it
    }
  }

async function validateZipcode(zipcode) {
    let url = `https://picdel.birdchime.com/script/availability`;
    try {
        const response = await fetch(url, {
          method: "POST",
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            domain: "andydrinks.myshopify.com", 
            postal_code: zipcode
          })
        });

        if (!response.ok) {
            throw new Error('Network response was not ok ' + response.statusText);
          return false;
        }
        const responseData = await response.json();
      // console.log(responseData)
      return responseData.local_delivery_applicable && responseData.local_delivery_available
    } catch (error) {
        console.error('There has been a problem with your fetch operation:', error);
      return false;
    }
}

async function submitCoverage(data) {
    let url = `https://n8n-1.o.growthist.io/webhook/coverage`;
    try {
        const response = await fetch(url, {
          method: "POST",
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(data)
        });
        if (!response.ok) {
            throw new Error('Network response was not ok ' + response.statusText);
        }
        const responseData = await response.json();
    } catch (error) {
        console.error('There has been a problem with your fetch operation:', error);
    }
}

async function getAccessToken() {
    const ACCESS_TOKEN_KEY = 'accessToken';
    const EXPIRY_KEY = 'accessTokenExpiry';

    function isTokenExpired() {
        const expiry = sessionStorage.getItem(EXPIRY_KEY);
        return !expiry || Date.now() > parseInt(expiry, 10);
    }

    function fetchAndStoreToken() {
        return fetch("/payments/config", { method: "GET" })
            .then(response => response.json())
            .then(config => {
                const newAccessToken = btoa(config.paymentInstruments.accessToken);
                const expiryTime = Date.now() + (60 * 60 * 1000); // 1 hour expiry

                sessionStorage.setItem(ACCESS_TOKEN_KEY, newAccessToken);
                sessionStorage.setItem(EXPIRY_KEY, expiryTime.toString());

                console.log('New Access Token:', newAccessToken);
                return newAccessToken;
            })
            .catch(error => {
                console.error('Error refreshing access token:', error);
                throw error;
            });
    }

    if (isTokenExpired()) {
        return fetchAndStoreToken();
    } else {
        const token = sessionStorage.getItem(ACCESS_TOKEN_KEY);
        console.log('Access token retrieved from session storage:', token);
        return Promise.resolve(token);
    }
}